var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',_vm._g(_vm._b({attrs:{"size":_vm.size,"color":_vm.avatarColor,"title":_vm.avatarTitle}},'v-avatar',_vm.$attrs,false),_vm.$listeners),[(_vm.avatarSrc)?_c('v-img',{attrs:{"src":_vm.avatarSrc}}):_c('span',{class:_vm.textStyle,domProps:{"textContent":_vm._s(_vm.initials)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }